import React from "react";
import { useSelector } from 'react-redux';
import { useNavigate} from "react-router-dom";



import {
  Pane,
  Paragraph,
  CogIcon,
  LogOutIcon,
  ErrorIcon,
  HomeIcon,
  Menu,
  Popover,
  Position,
  ChevronRightIcon
} from 'evergreen-ui';
import { useState } from 'react';
import CloudImage from "../CloudImage";


function UserMenu(props) {
  const currentpublisher = useSelector((state) => state.currentpublisher.value);
  const publishers = useSelector((state) => state.publishers.value);
  const publisherGlobalData = useSelector((state) => state.publisherGlobalData.value);
  const profile = useSelector((state) => state.profile.value);

  const navigate = useNavigate();


  const handleLogout = e => {
    e.preventDefault();

    // If impersonating, skip the logout API call to preserve the
    // impersonated user's token in the database
    if (localStorage.getItem('is_impersonating')) {
      localStorage.clear();
      window.location.replace('/login');
      return;
    }

    fetch('/api/v1/auth/logout/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    })
      .then(res => res.json())
      .then(data => {
        localStorage.clear();
        window.location.replace('/login');
      });
  };

  console.log(publishers);

  const isOwner = publishers.filter(item => item.role.name === "owner");



  return (
    <Pane>
      <Paragraph size={300} color="white" fontSize="10px" textTransform="uppercase" textAlign="left">{currentpublisher.name} </Paragraph>
      <Paragraph size={300} color="var(--lightgreen)" fontSize="10px" textTransform="uppercase" textAlign="left" marginLeft={4}>-- {publisherGlobalData.plan ? publisherGlobalData.plan : "Free Plan"} </Paragraph>

      {publishers.length > 0 &&
        <Pane marginTop={8} >

          <Popover
            content={({ close }) => (
              <Pane border="default">
                <Menu>
                  <Menu.Item icon={CogIcon} onSelect={e => {navigate('/settings'); close()}}>Settings</Menu.Item>
                  {/* {isOwner.length > 0 && <Menu.Item icon={HomeIcon} onSelect={e => {navigate('/publisher'); close()}}>Publisher Settings</Menu.Item>} */}
                  <Menu.Item icon={LogOutIcon} onSelect={e => handleLogout(e)}>Logout</Menu.Item>

                </Menu>
              </Pane>)}
            position={Position.RIGHT}>
            <Pane display="flex" alignItems="center" justifyContent="space-between" className="user-menu-button">
              <Pane display="flex" alignItems="center">
                <CloudImage
                  avatar={true}
                  size={30}
                  name={profile?.firstName ? `${profile.firstName} ${profile.lastName || ''}` : publishers[0]?.firstName ? `${publishers[0].firstName} ${publishers[0].lastName || ''}` : "User"}
                  src={profile?.photoUrl || publishers[0]?.photoUrl}
                />
                <Pane marginLeft={8} display="flex" flexDirection="column" alignItems="flex-start">
                  <Paragraph size={300} color="white">
                    Hi, {profile?.firstName || publishers[0]?.firstName || "User"}!
                  </Paragraph>
                </Pane>
              </Pane>
              <ChevronRightIcon marginLeft={8} size={14} color="white" />
            </Pane>
          </Popover>
        </Pane>

      }
    </Pane>
  );
}

export default UserMenu;
